/**
 *
 * @param value value of the threshold to apply (can be number "123" or percentage "65%")
 * @param maxLength value to calculate the percentage of the threshold (ie: 65% of 240), only needed if the value is in percentage form
 * @returns a number calculated for the percentage, the value as a number or maxLength value if unable to parse the value correctly, ie: not a valid number passed.
 */
export function getThresholdValue(value: string | number, maxLength: number, fallback?: number): number {
	if (value === undefined || value === null) return fallback ?? maxLength;

	if (maxLength && Number.isNaN(maxLength)) {
		console.warn('maxLength value is not a valid number');
	}

	let parsedValue: number;

	if (typeof value === 'string') {
		if (value.includes('%') && maxLength) {
			const percentageValue = Number(value.slice(0, -1));
			parsedValue = Math.round((percentageValue / 100) * maxLength);
		} else {
			parsedValue = Number(value);
		}
	}

	if (typeof value === 'number' && !Number.isNaN(value)) {
		parsedValue = value;
	}

	if (Number.isNaN(parsedValue)) {
		console.warn(`${value} is not a valid number or percentage`);
	}

	if (parsedValue > maxLength) {
		console.warn(`Threshold value ${parsedValue} is greater than maxlength ${maxLength}`);
	}

	return parsedValue ?? maxLength;
}
